import React from "react";
import type { IconProps } from "./icons";
import {
  AddTemplate,
  Approve,
  Bell,
  CalendarAlert,
  CalendarCheck,
  CalendarClock,
  Check,
  ChevronDown,
  ClockCircle,
  Close,
  Copy,
  DocumentUser,
  Download,
  DownloadPdf,
  Edit,
  EditImage,
  Employees,
  Folder,
  Home,
  HumanResources,
  Logout,
  Mail,
  MdiEye,
  MdiEyeOff,
  Menu,
  Office,
  Pause,
  Play,
  Plus,
  PrimeRefresh,
  Reject,
  Search,
  Send,
  SendMessage,
  Settings,
  SidebarCollapse,
  Sliders,
  UploadFile,
  User,
  Visibility,
  VisibilityOff,
  WhatsApp,
  WorkHistory,
} from "./icons";

const iconRegistry = {
  addTemplate: AddTemplate,
  approve: Approve,
  bell: Bell,
  send: Send,
  calendarAlert: CalendarAlert,
  calendarCheck: CalendarCheck,
  calendarClock: CalendarClock,
  workHistory: WorkHistory,
  check: Check,
  chevronDown: ChevronDown,
  clockCircle: ClockCircle,
  close: Close,
  copy: Copy,
  download: Download,
  documentUser: DocumentUser,
  downloadPdf: DownloadPdf,
  edit: Edit,
  editImage: EditImage,
  employees: Employees,
  folder: Folder,
  home: Home,
  humanResources: HumanResources,
  logout: Logout,
  mail: Mail,
  mdiEye: MdiEye,
  mdiEyeOff: MdiEyeOff,
  menu: Menu,
  office: Office,
  pause: Pause,
  play: Play,
  plus: Plus,
  refresh: PrimeRefresh,
  reject: Reject,
  search: Search,
  sendMessage: SendMessage,
  settings: Settings,
  sidebarCollapse: SidebarCollapse,
  sliders: Sliders,
  uploadFile: UploadFile,
  user: User,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  whatsapp: WhatsApp,
};

export type IconName = keyof typeof iconRegistry;

export interface OrIconProps extends IconProps {
  name: IconName;
}

export const OrIcon: React.FC<OrIconProps> = ({ name, ...props }) => {
  const IconComponent = iconRegistry[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent {...props} />;
};
